import { ConnectionRequestFilterState } from './models';

export const SPECIALTIES_OPTIONS = Object.keys(window.SPECIALTIES).map((key) => ({
  value: key,
  label: window.SPECIALTIES[key],
}));

export const CLEARANCE_STATUS_OPTIONS = Object.keys(window.CLEARANCE_STATUS).map((key) => ({
  value: key,
  label: window.CLEARANCE_STATUS[key],
}));

export const PRESENTATION_FACILITY_STATUS_OPTIONS = Object.keys(
  window.PRESENTATION_FACILITY_STATUS
).map((key) => ({
  value: key,
  label: window.PRESENTATION_FACILITY_STATUS[key],
}));

export const CONNECTION_REQUEST_STATUS_OPTIONS = Object.keys(window.CONNECTION_REQUEST_STATUS).map(
  (key) => ({
    value: key,
    label: window.CONNECTION_REQUEST_STATUS[key],
  })
);

export enum SortBy {
  UPDATED_AT = 'updated_at',
  PROVIDER_LAST_NAME = 'provider__last_name',
  PROVIDER_FIRST_NAME = 'provider__first_name',
  HEALTHCARE_REP_LAST_NAME = 'healthcare_entity_rep__user__last_name',
  PROVIDER_SPECIALTY = 'provider__specialties',
  FACILITY_NAME = 'facility__name',
  FACILITY_STATE = 'facility__state',
  ENTITY_NAME = 'facility__healthcare_entity__name',
}

export const SORT_OPTIONS_HCO = [
  { value: SortBy.PROVIDER_LAST_NAME, label: 'Provider' },
  { value: SortBy.FACILITY_NAME, label: 'Facility' },
  { value: SortBy.FACILITY_STATE, label: 'State' },
  { value: SortBy.PROVIDER_SPECIALTY, label: 'Specialty' },
  { value: SortBy.UPDATED_AT, label: 'Last Updated' },
];

export const SORT_OPTIONS_PROVIDER = [
  { value: SortBy.ENTITY_NAME, label: 'HCO' },
  { value: SortBy.HEALTHCARE_REP_LAST_NAME, label: 'Healthcare Representative' },
  { value: SortBy.FACILITY_NAME, label: 'Facility' },
  { value: SortBy.FACILITY_STATE, label: 'State' },
  { value: SortBy.UPDATED_AT, label: 'Last Updated' },
];

export const CONNECTION_DEFAULT_SORT_BY = SortBy.UPDATED_AT;
export const CONNECTION_DEFAULT_SORT_DIRECTION = 'desc';
export const CONNECTION_DEFAULT_ORDERING = `-${CONNECTION_DEFAULT_SORT_BY}`;

export const defaultFilter: ConnectionRequestFilterState = {
  specialties: [],
  facility: [],
  opportunity: [],
  statusCategory: '',
  search: '',
  sortBy: CONNECTION_DEFAULT_SORT_BY,
  sortDirection: CONNECTION_DEFAULT_SORT_DIRECTION,
  ordering: `-${CONNECTION_DEFAULT_SORT_BY}`,
};
